import React, { useState, useEffect } from "react";
import { imageCacheService } from "../../../providers/service/imageCacheService";

interface CachedImageProps {
  src: string;
  alt?: string;
  className?: string;
  cacheDuration?: number; // Cache duration in days
}

const CachedImage: React.FC<CachedImageProps> = ({
  src,
  alt,
  className = "",
  cacheDuration, // Default cache for n day
}) => {
  const [cachedSrc, setCachedSrc] = useState<string | null>(null);

  useEffect(() => {
    setCachedSrc(null); // Reset pour éviter d'afficher l'ancienne image
    const fetchCachedImage = async () => {
      const data = await imageCacheService.getCachedImage(src);
      setCachedSrc(data);
    };
    fetchCachedImage();
  }, [src, cacheDuration]);

  return (
    cachedSrc && (
      <img
        src={cachedSrc}
        alt={alt}
        draggable="false"
        className={className}
        loading="lazy"
      />
    )
  );
};

export default CachedImage;
